import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
  const splide01Elements = document.querySelectorAll(".splide01");
  if (splide01Elements.length > 0) {
    splide01Elements.forEach((element) => {
      new Splide(element, {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        interval: 3000,
        pauseOnHover: false,
        focus: 0,
      }).mount();
    });
  }
  const splide02Elements = document.querySelectorAll(".splide02");
  if (splide02Elements.length > 0) {
    splide02Elements.forEach((element) => {
      new Splide(element, {
        perPage: 3,
        type: "loop",
        focus: 0,
        autoScroll: {
          speed: 2,
        },
      }).mount({ AutoScroll });
    });
  }
  const splide03Elements = document.querySelectorAll(".splide03");
  if (splide03Elements.length > 0) {
    splide03Elements.forEach((element) => {
      new Splide(element, {
        perPage: 3,
        type: "loop",
        focus: 0,
        arrows: false,
        pagination: false,
        gap: "20px",
        drag: false,
        autoScroll: {
          speed: 0.8,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
        breakpoints: {
          767: {
            perPage: 2,
            gap: "5px",
            autoScroll: {
              speed: 0.5,
            },
          },
        },
      }).mount({ AutoScroll });
    });
  }
  const splideFoodElements = document.querySelectorAll(".splide-food");
  if (splideFoodElements.length > 0) {
    splideFoodElements.forEach((element) => {
      new Splide(element, {
        type: "loop",
        autoWidth: true,
        gap: "20px",
        arrows: false,
        pagination: false,
        drag: false,
        wheel: false,
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount({ AutoScroll });
    });
  }

  const pickUpMainElements = document.querySelectorAll(".splide-pickUp-main");
  if (pickUpMainElements.length > 0) {
    pickUpMainElements.forEach((element) => {
      const thumbElement = element
        .closest(".p-pickUp__slider")
        ?.querySelector(".splide-pickUp-thumbs");

      if (!thumbElement) return;

      const main = new Splide(element, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      });

      const thumbs = new Splide(thumbElement, {
        perPage: 4,
        perMove: 1,
        gap: 40,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        cover: true,
        breakpoints: {
          767: {
            fixedWidth: 120,
            fixedHeight: 73,
            gap: 8,
          },
        },
      });

      main.sync(thumbs);
      main.mount();
      thumbs.mount();
    });
  }

  const stageMainElements = document.querySelectorAll(".splide-stage-main");
  if (stageMainElements.length > 0) {
    stageMainElements.forEach((element) => {
      const thumbElement = element
        .closest(".p-stage__slider")
        ?.querySelector(".splide-stage-thumbs");

      if (!thumbElement) return;

      const thumbsWrap = thumbElement.closest(".p-stage__thumbs");

      const main = new Splide(element, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      });

      const thumbs = new Splide(thumbElement, {
        type: "loop",
        perPage: 5,
        perMove: 1,
        gap: 16,
        pagination: false,
        isNavigation: true,
        arrows: false,
        focus: 0,
        trimSpace: false,
        breakpoints: {
          767: {
            perPage: 2,
            gap: 10,
          },
        },
      });

      main.sync(thumbs);
      main.mount();
      thumbs.mount();

      const prevBtn = thumbsWrap?.querySelector(".p-stage__arrow--prev");
      const nextBtn = thumbsWrap?.querySelector(".p-stage__arrow--next");

      prevBtn?.addEventListener("click", () => {
        thumbs.go("<");
      });

      nextBtn?.addEventListener("click", () => {
        thumbs.go(">");
      });
    });
  }
}
